<template>
<div class="chapter">
<div class="inner_page">
<p class="bodytext-1"> </p>
<p class="bodytext-1"> </p>
<p class="extract"><a id="page_xii"></a>Regional map illustrates Meridian’s favorable</p>
<p class="extract">position between major cities of the South as well</p>
<p class="extract">as two major river traffic routes. <em>J. Parker Lamb</em>.</p>
<p class="image"><img alt="image" src="images/xii.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// foreword2.vue?01f81880